<template>
    <div class="app-container container">
      <el-form :model="queryParams" ref="queryForm" v-show="showSearch" :inline="true">
        <el-form-item label="角色名称" >
          <el-input v-model="queryParams.roleName" placeholder="请输入角色名称" clearable size="small" style="width: 240px"
                    @keyup.enter.native="handleQuery"/>
        </el-form-item>
        <el-form-item label="角色标识" >
          <el-input v-model="queryParams.roleKey" placeholder="请输入角色标识" clearable size="small" style="width: 240px"
                    @keyup.enter.native="handleQuery"/>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker v-model="dateRange" size="small" style="width: 240px" value-format="yyyy-MM-dd" type="daterange"
            range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery" >搜索</el-button>
          <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
  
      <el-row :gutter="10" class="mb8">
        <el-col :span="1.5">
          <el-button type="primary" plain icon="el-icon-plus" size="mini" @click="handleAdd"
                     >新增</el-button>
        </el-col>
      </el-row>
  
      <el-table v-loading="loading" :data="roleList">
        <el-table-column label="角色编号" prop="roleId" width="120" />
        <el-table-column label="角色名称" prop="roleName" :show-overflow-tooltip="true" width="150" />
        <el-table-column label="角色标识" prop="roleKey" :show-overflow-tooltip="true" width="150" />
        <!-- <el-table-column label="角色类型" prop="type" width="80">
          <template slot-scope="scope">
            <dict-tag :type="DICT_TYPE.SYSTEM_ROLE_TYPE" :value="scope.row.type"/>
          </template>
        </el-table-column> -->
        <el-table-column label="显示顺序" prop="roleSort" width="100" />
        <el-table-column label="状态" align="status" width="100">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.status" :active-value="0" :inactive-value="1" @change="handleStatusChange(scope.row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" align="center" prop="createTime" >
          <template slot-scope="scope">
            <span>{{ parseTime(scope.row.createTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
          <template slot-scope="scope">
            <el-button size="mini" type="text" icon="el-icon-edit" @click="handleUpdate(scope.row)" v-preventReClick
                      >修改</el-button>
            <el-button size="mini" type="text" icon="el-icon-circle-check" @click="handleMenu(scope.row)"
                       >菜单权限</el-button>
            <el-button size="mini" type="text" icon="el-icon-delete" @click="handleDelete(scope.row)" v-preventReClick
                       >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
  
      <pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize"
                  @pagination="getList"/>
  
      <!-- 添加或修改角色配置对话框 -->
      <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body>
        <el-form ref="form" :model="form" :rules="rules" label-width="80px">
          <el-form-item label="角色名称" prop="roleName">
            <el-input v-model="form.roleName" placeholder="请输入角色名称" />
          </el-form-item>
          <el-form-item label="角色标识" prop="roleKey">
            <el-input v-model="form.roleKey" placeholder="请输入角色标识" />
          </el-form-item>
          <el-form-item label="角色顺序" prop="roleSort">
            <el-input-number v-model="form.roleSort" controls-position="right" :min="0" />
          </el-form-item>
          <el-form-item label="数据范围" prop="dataScope">
            <el-select v-model="form.dataScope">
              <el-option value="1" label="菜单权限"></el-option>
              <el-option value="2" label="套餐权限"></el-option>
              <el-option value="3" label="仅本人数据权限"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm" :loading="btnLoading">确 定</el-button>
          <el-button @click="open = false">取 消</el-button>
        </div>
      </el-dialog>
      
      <!-- 分配角色的菜单权限对话框 -->
    <el-dialog :title="title" :visible.sync="openMenu" width="500px" append-to-body>
      <el-form :model="form" label-width="80px">
        <el-form-item label="角色名称">
          <el-input v-model="form.name" :disabled="true" />
        </el-form-item>
        <el-form-item label="角色标识">
          <el-input v-model="form.code" :disabled="true" />
        </el-form-item>
        <el-form-item label="菜单权限">
          <!-- <el-checkbox v-model="menuExpand" @change="handleCheckedTreeExpand($event, 'menu')">展开/折叠</el-checkbox> -->
          <el-checkbox v-model="menuNodeAll" @change="handleCheckedTreeNodeAll($event, 'menu')">全选/全不选</el-checkbox>
          <el-tree class="tree-border" :data="menuOptions" show-checkbox ref="menu" node-key="menuId"
              :check-strictly="form.menuCheckStrictly" empty-text="加载中，请稍后" :props="defaultProps"></el-tree>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitMenu" v-preventReClick :loading="btnLoading">确 定</el-button>
        <el-button @click="cancelMenu">取 消</el-button>
      </div>
    </el-dialog>
     
    </div>
  </template>
<script >
import { $role , $menu } from "@/services/admin";
export default{
    data(){
        return{
            showSearch:true,
            open:false,
            dateRange: [],
            roleList:[],
            loading:false,
            queryParams: {
                pageNum: 1,
                pageSize: 10,
                name: undefined,
                code: undefined,
                status: undefined
            },
            total:0,
            title:'',
            form:{},
            btnLoading:false,
             // 表单校验
            rules: {
              roleName: [
                { required: true, message: "角色名称不能为空", trigger: "blur" }
              ],
              roleKey: [
                { required: true, message: "角色标识不能为空", trigger: "blur" }
              ],
              roleSort: [
                { required: true, message: "角色顺序不能为空", trigger: "blur" }
              ],
              dataScope: [
                { required: true, message: "请选择数据范围", trigger: "change" }
              ]
            },
            menuOptions:[],
            openMenu:false,
            defaultProps: {
              label: "menuName",
              children: "children"
            },
            menuExpand: false,
            menuNodeAll:false,
        }
    },
    mounted( ){
      this.getList();
    },
    methods:{
        resetQuery(){},
        handleQuery(){
          this.getList();
        },
        handleUpdate( row ){
          this.reset();
          const id = row.roleId
          $role.roleDataById(id).then(response => {
            let { roleId , roleKey , roleName , roleSort , dataScope  } =  response.data
            this.form = { roleId , roleKey , roleName , roleSort , dataScope  };
            this.open = true;
            this.title = "修改角色";
          });
        },
        handleStatusChange( row ){
          $role.editRole({ 
            roleId : row.roleId , 
            status:row.status ,
            roleSort: row.roleSort ,
            roleKey:row.roleKey,
            roleName:row.roleName
            }).then(() => {
            this.btnLoading = false;
            this.$message.success('修改成功');
            this.open = false;
            this.getList();
          }).catch(()=>{ this.btnLoading = false; });
        },
        /** 分配菜单权限操作 */
      handleMenu(row) {
        this.reset();
        // const id = row.roleId
        // 处理了 form 的角色 name 和 code 的展示
        this.form.id = row.roleId;
        this.form.name = row.roleName;
        this.form.code = row.roleKey;
        // 打开弹窗
        this.openMenu = true;
        // 获得菜单列表
        $menu.menuList().then(response => {
          // 处理 menuOptions 参数
          this.menuOptions = [];
          this.menuOptions.push(...this.handleTree(response.data, "menuId"));
          // 获取角色拥有的菜单权限
          $role.getBindMenu( row.roleId ).then(response => {
            // 设置为严格，避免设置父节点自动选中子节点，解决半选中问题
            this.form.menuCheckStrictly = true
            // 设置选中
            this.$refs.menu.setCheckedKeys(response.data);
            // 设置为非严格，继续使用半选中
            this.form.menuCheckStrictly = false
          })
        });

      },
      // 树权限（展开/折叠）
    handleCheckedTreeExpand(value, type) {
      if (type === 'menu') {
        let treeList = this.menuOptions;
        for (let i = 0; i < treeList.length; i++) {
          this.$refs.menu.store.nodesMap[treeList[i].id].expanded = value;
        }
      } else if (type === 'dept') {
        let treeList = this.deptOptions;
        for (let i = 0; i < treeList.length; i++) {
          this.$refs.dept.store.nodesMap[treeList[i].id].expanded = value;
        }
      }
    },
    // 树权限（全选/全不选）
    handleCheckedTreeNodeAll(value, type) {
      if (type === 'menu') {
        this.$refs.menu.setCheckedNodes(value ? this.menuOptions: []);
      } else if (type === 'dept') {
        // this.$refs.dept.setCheckedNodes(value ? this.deptOptions: []);
        this.$refs.dept.setCheckedNodes(value ? this.depts: []);
      }
    },
     // 取消按钮（菜单权限）
     cancelMenu() {
      this.openMenu = false;
      this.reset();
    },
       /** 提交按钮（菜单权限） */
    submitMenu: function() {
      console.log( this.form )
      if (this.form.id !== undefined) {
        this.btnLoading = true;
        let data = {
          roleId: this.form.id,
          menuIds: [...this.$refs.menu.getCheckedKeys(), ...this.$refs.menu.getHalfCheckedKeys()]
        };
        console.log( data )
        $role.roleBindMenu(data).then(() => {
          this.btnLoading = false;
          this.$message.success('修改成功');
          this.openMenu = false;
          this.getList();
        }).catch(()=>{ this.btnLoading = false; });
      }
    },
        handleDelete( row ){
          $role.delRole( row.roleId ).then(() => {
            this.$message.success('删除成功');
            this.getList();
          });
        },
        handleAdd() {
          this.reset();
          this.open = true;
          this.title = "添加角色";
        },
        async getList(){
          this.queryParams.startTime = this.dateRange[0] ? this.dateRange[0] + ' 00:00:00' : undefined;
          this.queryParams.endTime = this.dateRange[1] ? this.dateRange[1] + ' 23:59:59' : undefined;
          let res = await $role.roleList(this.queryParams)
          console.log( res )
          if( res.code == 200 ){
            this.total = res.data.total;
            this.roleList = res.data.records;
            console.log( this.roleList )
          }
        },
        /** 提交按钮 */
        submitForm: function() {
          this.$refs["form"].validate(valid => {
            if (valid) {
              this.btnLoading = true;
              if (this.form.roleId !== undefined) {
                $role.editRole(this.form).then(() => {
                  this.btnLoading = false;
                  this.$message.success('修改成功');
                  this.open = false;
                  this.getList();
                }).catch(()=>{ this.btnLoading = false; });
              } else {
                $role.addRole(this.form).then( () => {
                  this.btnLoading = false;
                  this.$message.success('新增成功');
                  this.open = false;
                  this.getList();
                }).catch(()=>{ this.btnLoading = false; });
              }
            }
          });
        },
        cancel(){},
        reset() {
          if (this.$refs.menu !== undefined) {
            this.$refs.menu.setCheckedKeys([]);
          }
          this.menuExpand = false;
          this.menuNodeAll = false;
          this.deptExpand = true;
          this.deptNodeAll = false;
          this.form = {
            roleId: undefined,
            roleName: undefined,
            roleKey: undefined,
            roleSort: 0,
            dataScope: '1',
            status: 0,
          };
          this.resetForm("form");
        },
    }
}
</script>